const buildLinkedData = (storeConf) => {
  if (!storeConf) {
    return '';
  }

  const json = {
    '@context': 'https://schema.org',
    type: 'Organization',
    name: storeConf.store_name,
    url: storeConf.url,
    logo: storeConf.logo,
    image: storeConf.image,
    description: storeConf.description,
    sameAs: [
      storeConf.facebook,
      storeConf.twitter,
      storeConf.youtube,
      storeConf.google,
      storeConf.instagram
    ],
    address: {
      '@type': 'PostalAddress',
      streetAddress: storeConf.streetAddress,
      postOfficeBoxNumber: storeConf.postOfficeBoxNumber,
      addressLocality: storeConf.addressLocality,
      addressRegion: storeConf.addressRegion,
      postalCode: storeConf.postalCode,
      addressCountry: {
        '@type': 'Country',
        name: storeConf.country
      }
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: storeConf.telephone,
      contactType: 'Customer Service'
    },
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: storeConf.urlTemplate
      },
      'query-input': {
        '@type': 'PropertyValueSpecification',
        valueRequired: 'https://schema.org/True',
        valueName: 'search_term'
      }
    }
  };
  return json;
};

export default buildLinkedData;
